import Vue from 'vue'
import Router from 'vue-router'
import Welcome from './views/Welcome.vue'
import Selection from './views/Selection.vue'
import Menu from './views/Menu.vue'
import Practice from './views/Practice.vue'
import FreeTalk from './views/FreeTalk.vue'
import Instruction from './views/Instruction.vue'
import PracticeStart from './views/PracticeStart.vue'
import Result from './views/Result.vue'
import FreeTalkStart from './views/FreeTalkStart.vue'
import store from './store';
import {isEmpty} from "@firebase/firestore/dist/src/util/obj";


Vue.use(Router)

const router =  new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'welcome',
      component: Welcome
    },
    {
      path: '/selection',
      component: Selection
    },
    {
      path:'/instruction',
      component: Instruction,
    },
    {
      path: '/menu',
      component: Menu
    },
    {
      path: '/practice',
      component: Practice
    },
    {
      path: '/practice-start',
      component: PracticeStart
    },
    {
      path: '/result',
      component: Result,
      props: true
    },
    {
      path:'/free',
      component: FreeTalk
    },
    {
      path:'/free-start',
      component: FreeTalkStart
    },
    { path: "*", redirect: '/' }

  ]
});


router.beforeEach((to, from, next) => {
  if (to.fullPath == "/instruction" || to.fullPath == "/menu" || to.fullPath == "/practice"  || to.fullPath == "/practice-start"
      || to.fullPath == "/result" || to.fullPath == "/free" || to.fullPath == "/free-start"  ) {
    if (Object.entries(store.state.character).length === 0 && store.state.character.constructor === Object) {
      next('/selection');
    }}
  next();
});

export default router;
